function log_entries_Reducer(state = [], action) {
    switch (action.type) {
        case 'LOG/ENTRIES/SET':            
            return action.log_entries;
        case 'LOG/ENTRIES/CLEAR':
            return null;
        default:
            return state;
    }
}

export default log_entries_Reducer;
